<template>
  <div>
    <ChengKuangApply v-if="userInfo.businessGroup == '城矿'" />
    <WuMaoApply v-else />
  </div>
</template>

<script>
  import ChengKuangApply from './chengKuangApply/list.vue';
  import WuMaoApply from './paymentApply/list.vue';
  export default {
    name: 'paymentApplyList',
    components: { ChengKuangApply, WuMaoApply },
  };
</script>

<style lang="scss" scoped></style>
